import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import IndustriesPage from "@/pages/Industries";

export const Route = createFileRoute("/$lang/industries/")({
  head: ({ params }) => pageHead(params.lang, "industries"),
  component: IndustriesPage,
});
